import { render, staticRenderFns } from "./ThematicAreaReport.vue?vue&type=template&id=23fea536&scoped=true"
import script from "./ThematicAreaReport.vue?vue&type=script&lang=js"
export * from "./ThematicAreaReport.vue?vue&type=script&lang=js"
import style0 from "./ThematicAreaReport.vue?vue&type=style&index=0&id=23fea536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fea536",
  null
  
)

export default component.exports